import { replaceLink, replaceEmail } from 'shared/lib'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { mergeFieldReplacer } from 'entities/Message/lib/mergeFieldReplacer'
import { tagReplacer } from 'entities/Message/lib/tagReplacer'
import { escapeHtml } from 'entities/Message/lib/escapeHtml'
import { actionChipReplacer } from 'entities/AIAgent/lib/agentActions'

type ItextToHtmlProps = {
  text: string
  replaceNewRow?: boolean
  noMergeField?: boolean
  isClearMergeField?: boolean
  ignoreLinks?: boolean
  noReplaceMergeField?: boolean
  extraSpace?: boolean
  noEscapeHtml?: boolean
  replaceActionChips?: boolean
}

export function textToHtml(
  entities: IEntitiesStore,
  {
    text,
    replaceNewRow,
    noMergeField,
    noReplaceMergeField,
    isClearMergeField,
    ignoreLinks,
    extraSpace,
    noEscapeHtml,
    replaceActionChips,
  }: ItextToHtmlProps
) {
  const safeText = noEscapeHtml ? text : escapeHtml(text)
  if (!safeText) return ''

  const content = extraSpace ? safeText + ' ' : safeText
  const normalizedContent = ignoreLinks
    ? content
    : content
        .split(/\n/)
        .map((text) =>
          text
            .split(' ')
            .map((word) => replaceLink(word))
            .map((word) => replaceEmail(word))
            .join(' ')
        )
        .join('\n')

  if (replaceNewRow) {
    return normalizedContent
      .replace(/\[.*?\]/g, (match) => tagReplacer(match))
      .replace(/{.*?}/g, (match) =>
        noReplaceMergeField
          ? match
          : mergeFieldReplacer(entities, match, noMergeField, isClearMergeField)
      )
      .replace(/@\w+\((?:\{.*?\})?\)/g, (match) =>
        replaceActionChips ? actionChipReplacer(match) : match
      )
      .split('\n')
      .map((item, index, self) =>
        index > 1
          ? `<span aria-label='textContent'>${item}${index === self.length ? '' : '<br/>'}</span>`
          : `<span aria-label='textContent'>${item}<br/></span>`
      )
      .join('')
  }

  return normalizedContent.replace(/{.*?}/g, (match) =>
    noReplaceMergeField
      ? match
      : mergeFieldReplacer(entities, match, noMergeField, isClearMergeField)
  )
}
